import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {HttpClientModule} from '@angular/common/http';
import {RouterModule} from '@angular/router';
import {PerfectScrollbarModule} from 'ngx-perfect-scrollbar';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {StopTitlePipe} from './pipes/stop-title.pipe';
import {RouteGroupTitlePipe} from './pipes/route-group-title.pipe';
import {UserPipe} from './pipes/user.pipe';
import { VehicleModelPipe } from './pipes/vehicle-model.pipe';
import { VehicleCapacityPipe } from './pipes/vehicle-capacity.pipe';
import { DispatchGroupTitlePipe } from './pipes/dispatch-group-title.pipe';
import { RoutePipe } from './pipes/route.pipe';
import {StatusClassPipe} from './pipes/status-class.pipe';
import { UserLevelPipe } from './pipes/user-level-pipe.pipe';
import { DiscountAmountPipe } from './pipes/discount-amount.pipe';
import { TimeFormatPipe } from './pipes/time-format.pipe';
import { SafeHtmlPipe } from './pipes/safeHtml.pipe';
import { UserAgencyPipe } from './pipes/user-agency.pipe';
import { UserPhonePipe } from './pipes/user-phone.pipe';
import { UserNamePipe } from './pipes/user-name.pipe';
import { CapitalizePipe  } from './pipes/capitalize.pipe';
@NgModule({
    exports: [
        CapitalizePipe,
        CommonModule,
        FormsModule,
        HttpClientModule,
        PerfectScrollbarModule,
        NgbModule,
        StopTitlePipe,
        RouteGroupTitlePipe,
        UserPipe,
        VehicleModelPipe,
        VehicleCapacityPipe,
        DispatchGroupTitlePipe,
        StatusClassPipe,
        UserLevelPipe,
        DiscountAmountPipe,
        TimeFormatPipe,
        SafeHtmlPipe,
        UserAgencyPipe,
        UserPhonePipe,
        UserNamePipe,
        CapitalizePipe
    ],
    imports: [
        RouterModule,
        CommonModule,
        PerfectScrollbarModule,
        NgbModule
    ],
    declarations: [
        CapitalizePipe,
        StopTitlePipe,
        RouteGroupTitlePipe,
        UserPipe,
        VehicleModelPipe,
        VehicleCapacityPipe,
        DispatchGroupTitlePipe,
        RoutePipe,
        StatusClassPipe,
        UserLevelPipe,
        DiscountAmountPipe,
        TimeFormatPipe,
        SafeHtmlPipe,
        UserAgencyPipe,
        UserPhonePipe,
        UserNamePipe
    ],
    providers: []
})

export class SharedModule {
}
